import { gql } from '@apollo/client';

export const ACCOUNT = gql`
  query account {
    account {
      id
      type
      title
      status
      balanceInCents
      subaccounts {
        id
        childId
        type
        title
        balanceInCents
        riskScore
        enableDynamicRisk
      }
    }
  }
`;
